<template>
<div>
  <asideNav :isShowDot="isShowDot">
    <div class="systemMessage" >
      <div class="messageTitle">系统消息（<strong>{{systemMessage}}</strong>）</div>
      <ul class="messageList">
        <li v-for="(item,index) in messageList" @mouseenter="_mouseenter(index)" @mouseleave="_mouseleave(index)" :class="{'active':index==listIndex}" :key="item.id">
          <div class="meeting-top">
            <i v-if="item.messageTopicCode === '08' || item.messageTopicCode ===  '09'" class="iconfont icon-xinjiankecheng" style="font-size: 30px !important;"></i>
            <i v-else class="iconfont icon-xinjianhuiyi" style="font-size: 30px !important;"></i>
            <p @click="gotoRouter(item)">{{item.msgContent}}</p>
          </div>
          <div class="meeting-btm">
            <p>{{item.formUserName}}</p>
              <span v-if="see&&index==listIndex">
                <i class="icon_msg icon-bukejian"  @click="addIgnore(index)"  title="点击忽略"></i>
              </span>
              <span v-else><i class="msg_read" v-if="item.readStatus === '3'">已读</i><i class="msg_read" v-if="item.isTimeOut">已过期</i>{{item.createDate_new}}</span>
          </div>
        </li>
      </ul>
      <div class="allMessage">
        <p>会议消息 <strong>{{meetingMessage}}</strong></p>
        <p>课程消息 <strong>{{courseMessage}}</strong></p>
        <a href="javascript:;" @click="addIgnore">忽略全部</a>
      </div>
    </div>
  </asideNav>

  <passwordInput v-show="popPassword" :isShowPassword="popPassword" @clossPassword="clossPassword" @inputPassword="inputPassword"></passwordInput>

</div>
</template>
<script type="text/ecmascript-6">
    import asideNav from '@/components/common/message/asideNav';
    import passwordInput from '@/components/common/message/passwordInput';
    import {cookies} from '../../../api/util'
    import * as _ from '@/common/js/config'
    import {message} from '@/common/js/messages'
    import {getLocalStorage, saveLocalStorage, clearLocalStorage} from '@/common/js/localStorage'
    import http from '@/api/http'
    import tixing from "@/assets/audio/tixing.wav";
    export default {
      components:{
        asideNav,
        passwordInput
      },
        data() {
            return {
              isShowDot:false,//是否显示红点
              systemMessage:0,
              meetingMessage:0,
              courseMessage:0,
              see:false,
              listIndex:-1,
              messageList:[],
              ws:"",//WebSocket连接
              popPassword:false,//是否显示密码框
              meetingId:0,//当前被点击的会议消息id 用于存在密码时 请求接口
              audio: new Audio(),//提示音
              lockReconnect :false,  //避免ws重复连接
              userInfo:"",
            }
        },
        created(){
          this.audio.src = tixing;//设置提示音

          this.userInfo = cookies.getCookie('eimageglobaltid')

          this.createWebSocket();
          const that = this;

          this.ws.onmessage = function(e){

            that.handlMessage(e.data);
          };
          this.ws.onerror = function () {
                console.log("llws连接错误!");
                //尝试重新连接
                that.reconnect();
            };
        },
        methods: {
          //建立socket连接
          createWebSocket(){
            if ('WebSocket' in window){
              this.ws = new WebSocket(`${window.WebSocket_URL}?eimageglobaltid=${this.userInfo}`);
            }else if('MozWebSocket' in window){
              this.ws = new MozWebSocket(`${window.WebSocket_URL}?eimageglobaltid=${this.userInfo}`);
            }else{
              this.ws = new SockJS(`${window.WebSocket_URL_HTTP}?eimageglobaltid=${this.userInfo}`);
            }
          },
          //重连socket
          reconnect() {
              const that = this;
              if (this.lockReconnect) return;
              this.lockReconnect = true;
              setTimeout(function () {     //没连接上会一直重连，设置延迟避免请求过多
                  that.createWebSocket();
                  that.lockReconnect = false;
              }, 5000);
          },
          // 语音播放
          aplayAudio () {
           this.audio.play()
          },
          clossPassword(){
            this.popPassword=false;
          },
          inputPassword(psw){
            let params = {
              id: this.meetingId,
              confPwd: psw
            }
            http.post('/conference/getTopicConfDetail.json', params).then(res => {
              if (res.data.code === _.ERR_OK) {
                this.popPassword = false
                saveLocalStorage(psw, 'ConfPasswordVal')
                this.$router.push({name: 'QueryManageMeeting'})
                //主要解决 当当前已经处在会议详情页 再次点击刷新数据
                this.$events.$emit("toQueryManageMeeting");
              } else {
                message(res.data.msg, false)
              }
            })
          },
          gotoRouter(item){
            const {toMeeting,toClass,relId,hasConfPwd,id,userId} = item;
            if(toMeeting){
              //进入会议需要判断是否需要输入密码
              saveLocalStorage(relId, 'idVal');
              this.meetingId = relId;//主要是用于存在密码时发送请求
              if(hasConfPwd === '1') {
                this.popPassword = true
              } else {
                saveLocalStorage("", 'ConfPasswordVal')
                this.$router.push({name: 'QueryManageMeeting'})
                //主要解决 当当前已经处在会议详情页 再次点击刷新数据
                this.$events.$emit("toQueryManageMeeting");
              }

            }else if(toClass){
              saveLocalStorage( relId,'Id');
              this.$router.push({name: "LookCourse",params:{id:relId}});
              //主要解决 当当前已经处在课程详情页 再次点击刷新数据
              this.$events.$emit("toLookCourse");

            }
            //修改状态为已读
            item.readStatus="3";
            this.chickDot();
            //调用已读接口
            this.ws.send(`{method:"theUserHasReaded",body:{taskId:${id}, formUser:${userId}}}`);
          },
          handlMessage(data){
            data = JSON.parse(data);
           // console.log(data)
            if(data.code === _.ERR_OK){
              const model = data.model;
              if(model.length>0){
                this.aplayAudio();
                let meetingCount = 0;//会议数量
                let classCount = 0;//课程数量

                const cancelList=[];//取消的会议id记录;
                model.forEach(item => {

                  const {messageTopicCode,createDate} = item
                  //createDate特殊处理 去掉 年跟秒
                  if(createDate){
                    item.createDate_new = createDate.slice(5,16)
                  }

                  //消息类型 05专题会议创建 06专题会议撤销 07专题会议即将开始 08直播课程创建 09直播课程即将开始
                  switch (messageTopicCode) {
                    case "05":
                      meetingCount++;
                      //增加参数toMeeting字段表示 可以跳转到会议详情
                      item.toMeeting = true;
                      break;
                    case "06":
                      meetingCount++;
                      cancelList.push(item.relId)//记录被撤销的消息id
                      break;
                    case "07":
                      meetingCount++;
                      //增加参数toMeeting字段表示 可以跳转到会议详情
                      item.toMeeting = true;
                      break;
                    case "08":
                      classCount++;
                      //增加参数toClass字段表示 可以跳转到会议详情
                      item.toClass = true;
                      break;
                    case "09":
                      classCount++;
                      //增加参数toClass字段表示 可以跳转到会议详情
                      item.toClass = true;
                      break;

                    default:
                      break;
                  }
                });
                //先将model加入到messageList中 加到头部
                this.messageList.unshift(...model);
                //再根据cancelList判断将对应的会议 去掉跳转 即toMeeting改为false
                //分开两次是为了避免循环套循环
                if(cancelList.length>0){
                    this.messageList.forEach(item=>{
                      if(cancelList.indexOf(item.relId) !== -1 && item.messageTopicCode !=="06" ){
                        item.toMeeting = false;
                        item.isTimeOut = true;
                      }
                    })
                }
                this.chickDot();
                //因为除了第一次往后 消息为单独发送 所以计算值需要往上加
                this.meetingMessage = this.meetingMessage + meetingCount;
                this.courseMessage = this.courseMessage +classCount;
                this.systemMessage = this.systemMessage +classCount +meetingCount;
              }

            }else{
              message(data.msg, false);
            }
          },
          //判断是否存在未读消息 存在则显示小红点
          chickDot(){
            this.isShowDot = !this.messageList.every(item=>{
                return item.readStatus === "3"
            })
          },
          addIgnore(i){
            let id ="";
            let userId ="";

            if(i > 0 || i === 0){
              //根据messageTopicCode 重新计算 systemMessage meetingMessage courseMessage
              const msg = this.messageList[i];
              id = msg.id;
              userId = msg.userId;
              //重新计算数量
              const messageTopicCode = this.messageList[i].messageTopicCode
              //消息类型 05专题会议创建 06专题会议撤销 07专题会议即将开始 08直播课程创建 09直播课程即将开始
              if(messageTopicCode === "05" ||messageTopicCode === "06" ||messageTopicCode === "07"){
                this.meetingMessage--
              }else if(messageTopicCode === "08" ||messageTopicCode === "09"){
                this.courseMessage--
              }
              this.systemMessage--;
              //去掉该条
              this.messageList.splice(i, 1);
              this.ws.send(`{method:"setMessageIgnore",body:{taskId:${id}, formUser:${userId}}}`);
            }else{
              if(this.messageList.length>0){
                id="";
                userId= this.messageList[0].userId;
                this.messageList=[];
                //数量置空
                this.systemMessage=0;
                this.meetingMessage=0;
                this.courseMessage=0;
                //调用 忽略接口
                this.ws.send(`{method:"setMessageIgnore",body:{formUser:${userId}}}`);

              }else{
                message("当前无数据",false);
                return;
              }
            }
            this.chickDot();
          },
          _mouseenter(index){
            this.see = true
            this.listIndex = index
          },
          _mouseleave(index){
            this.see = false
            this.listIndex = -1
          },

          clearAll(){
            this.messageList = []
          },
        },
    }
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
  .msg_read
    margin-right 10px;
    color :#f56c6c;
  .icon_msg
    display: inline-block;
    margin-top: -4px;
    cursor: pointer;

  .systemMessage
    // border-top:6px solid #42B8B8
    background:#fff
    width:300px
    box-shadow: 0 0 20px 3px rgba(0, 0, 0, 0.1)
  .messageTitle
    height:36px
    line-height:36px
    font-size:16px
    padding:0 10px 0 14px
    strong
      color:#42B8B8
      font-size:17px
    .close
      float:right
      width:20px
      height:20px
      background:#000
      margin:10px 6px 0 0

  .messageList
    max-height: 300px
    overflow-y: auto
    .active
      background:#E3E9F7
    li
      border-bottom:1px dashed #EAECED
      padding:10px 10px 10px 14px
      min-height:30px
      .meeting-btm,.meeting-top
        overflow:hidden
      .meeting-top
        i
          position: relative;
          top: 15px;
          color #00adaa
        p
          cursor: pointer;
          float:right
          width:calc(100% - 40px)
          margin-left:10px
          color:#000;
          line-height: 20px;
      .meeting-btm
        padding-left:40px
        margin-top:10px
        height: 16px
        line-height:16px
        p
          float:left
        span
          float:right
          padding-right:6px
          a
            display:inline-block
            width:20px
            height: 16px
            background:#fff
  .allMessage
    height: 45px
    display:flex
    justify-content :center
    align-items :center
    p
      width:calc(45% - 30px)
      line-height:45px
      strong
        color:#42B8B8
    a
      width:70px
      height:24px
      line-height:24px
      background:#ACAEB4
      color:#fff
      text-align:center
      border-radius:3px
</style>



// WEBPACK FOOTER //
// systemMessage.vue?57b3b3eb